const drawerCatalog = document.getElementById('lds-catalog-drawer');
const drawerInnerCatalog = drawerCatalog.querySelector('.lds-catalog-drawer_inner');
const overlayCatalog = document.getElementById('lds-catalog-overlay');
const closeBtnCatalog = document.getElementById('CloseCatalog');

const openDrawerCatalog = () => {
  drawerCatalog.classList.remove('translate-x-full');
  drawerCatalog.classList.add('translate-x-0');

  overlayCatalog.classList.remove('opacity-0', 'pointer-events-none');
  overlayCatalog.classList.add('opacity-50');

  document.body.classList.add('overflow-hidden');
};

const closeDrawerCatalog = () => {
  drawerCatalog.classList.add('translate-x-full');
  drawerCatalog.classList.remove('translate-x-0');

  overlayCatalog.classList.remove('opacity-50');
  overlayCatalog.classList.add('opacity-0');

  setTimeout(() => {
    overlayCatalog.classList.add('pointer-events-none');
    document.body.classList.remove('overflow-hidden');
  }, 300);
};

// ouverture via bouton class
document.addEventListener('click', function (event) {
  if (event.target.closest('.lds-catalog-toggle')) {
    openDrawerCatalog();
  }
});

// fermeture via bouton
closeBtnCatalog?.addEventListener('click', closeDrawerCatalog);

// fermeture via clic en dehors de l'intérieur du drawer
drawerCatalog.addEventListener('click', (event) => {
  if (!drawerInnerCatalog.contains(event.target)) {
    closeDrawerCatalog();
  }
});

// Shopify édition : ouverture uniquement si section sélectionnée
if (window.Shopify && window.Shopify.designMode) {
  const sectionId = drawerCatalog.dataset.sectionId;

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail.sectionId === sectionId) {
      openDrawerCatalog();
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.detail.sectionId === sectionId) {
      closeDrawerCatalog();
    }
  });
}
